module.exports = __webpack_public_path__ + "9612b438bf12d5b56d6a66ed0c51983a.jpg";